module.exports = __webpack_public_path__ + "img/services-2.91eae839.png";